import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=43bf6712&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=43bf6712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf6712",
  null
  
)

export default component.exports